import * as React from "react"
import { CSSProperties } from "react"
import { OpportunityData } from "../EntityType"
import MobileCrmData from "../MobileCrmData"
import { ListItemWrapper } from "../list/ListItemWrapper"
import { ListItemStateContent } from "../list/ListItemStateContent"
import { ListItemCallbackProps } from "../list/MobileListDataWrapper"
// import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// import {Link} from "react-router-dom";

export type OpportunityDataProps = {
	data: OpportunityData, table: string,
	style: CSSProperties,
	index: number,
} & ListItemCallbackProps;

const ItemLeftSide = ( props: OpportunityDataProps ) => {
	return <>
		<div className={ "itemFirm" }>
			<span dangerouslySetInnerHTML={ { __html: props.data.firmName } } />
		</div>
		{ props.data.priorityName &&
			<span className={ "itemType" }>
				{ props.data.priorityName }
			</span> }
	</>
}
const ItemRightSide = ( props: OpportunityDataProps ) => {
	return <>
		{
			props.data.dateNextAction &&
			<div className={ "itemDateNextAction" }>
				{ props.data.dateNextAction }
			</div>
		}
		{
			props.data.permission.assignedUserId.map( ( userId, index ) => (
				<span key={ index }>
					{ MobileCrmData.getUserNameById( userId ) }
 					</span>
			) )
		}
	</>
}
const ItemBasic = ( props: OpportunityDataProps ) => {
	return <ListItemStateContent statusColor={ props.data.statusColor } statusName={ props.data.statusName } isClosed={ props.data.isClosed } />
}

const OpportunityListItem = ( props: OpportunityDataProps ) => {

	return (
		<ListItemWrapper
			tagColor={ props.data.statusColor }
			name={ props.data.name } table={ props.table }
			isClosed={ props.data.isClosed }
			permission={ props.data.permission } id={ props.data.id }
			itemExpandLeftElement={ <ItemLeftSide { ...props } /> }
			itemBasicElement={ <ItemBasic { ...props } /> }
			itemExpandRightElement={ <ItemRightSide { ...props } /> }
			style={ props.style } index={ props.index }
			onDeleteItemCallback={ props.onDeleteItemCallback }
			onEditItemCallback={ props.onEditItemCallback }
			onListMessageCallback={ props.onListMessageCallback }
			onLoadingStart={props.onLoadingStart}
		/>
	)
}

export default OpportunityListItem
